import React, { Component } from 'react';

var Key = React.createClass({
  actionClickButton: function(){
    this.props.actionClickButton(this.props.val)
  },
  render: function(){
    if(this.props.probel){
      return(
        <div className={"button probel " + this.props.className} onClick={this.actionClickButton} style={this.props.style}>___</div>
      );
    }else{
      if(this.props.mobile){
        return(
          <div className={"button " + this.props.className}>
            <div className="wrapper" onClick={this.actionClickButton} style={this.props.style}>{this.props.val}</div>
          </div>
        )
      }else{
        return(
          <div className={"button " + this.props.className} onClick={this.actionClickButton} style={this.props.style}>{this.props.val}</div>
        );
      }
    }
  }
});

var testKeyFromArr = function(key, arr){
  for(var item of arr){
    if(new RegExp(key, 'i').test(item)){
      return true;
    }
  }
  return false;
}

export {testKeyFromArr}

export default Key;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppForm/components/KeyboardWrapper/components/KeyboardsSwitcher/components/Key/index.jsx
 **/